import { Backdrop, CircularProgress } from '@mui/material';

export const Spinner = ({ open = true }) => {
  return (
    <Backdrop sx={{ color: '#fff', zIndex: 2500 }} open={open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
};
